module.exports = __webpack_public_path__ + "img/message.3d0318ae.svg";